import { t } from 'i18next';

const getPlanTableLabel = (key: string): string => {
  const labels: Record<string, string> = {
    plan: t('billing.plan_table.plan'),
    seats: t('billing.plan_table.seats'),
    sessions: t('billing.plan_table.sessions'),
    users: t('billing.plan_table.users'),
    analytics: t('billing.plan_table.analytics'),
    coupon: t('billing.plan_table.coupon'),
  };
  return labels[key] ?? key;
};

/** Formats an amount (in smallest currency unit) as a localized price string. */
const formatPrice = (amount: number | undefined | null, currency: string): string =>
  t('billing.price', {
    0: (amount ?? 0) / 100,
    formatParams: { 0: { currency: currency.toUpperCase() } },
  });

export { getPlanTableLabel, formatPrice };
